import { useState, type ComponentProps, type ReactElement } from "react";
import { ScaledSlideRenderer } from "./ScaledSlideRenderer.js";

type RendererProps = ComponentProps<typeof ScaledSlideRenderer>;

export const previewScreenPresets = [
  { id: "hd", label: "HD display", width: 1280, height: 720 },
  { id: "desktop", label: "Desktop", width: 1366, height: 768 },
  { id: "full-hd", label: "Full HD TV", width: 1920, height: 1080 },
  { id: "ultrawide", label: "Ultrawide display", width: 2560, height: 1080 },
  { id: "4k", label: "4K TV", width: 3840, height: 2160 },
  { id: "portrait-signage", label: "Portrait signage", width: 1080, height: 1920 },
] as const;

export function ScreenPreview(props: RendererProps): ReactElement {
  const matchingPreset = previewScreenPresets.find(
    (preset) =>
      preset.width === props.definition.canvas.width &&
      preset.height === props.definition.canvas.height,
  );
  const [presetId, setPresetId] = useState(matchingPreset?.id ?? "full-hd");
  const preset =
    previewScreenPresets.find((candidate) => candidate.id === presetId) ?? previewScreenPresets[2];

  return (
    <div className="screen-preview">
      <div className="screen-preview__toolbar">
        <label>
          <span>Preview screen</span>
          <select
            value={preset.id}
            onChange={(event) => setPresetId(event.target.value as typeof presetId)}
          >
            {previewScreenPresets.map((candidate) => (
              <option key={candidate.id} value={candidate.id}>
                {candidate.label} · {candidate.width} × {candidate.height}
              </option>
            ))}
          </select>
        </label>
        <span className="screen-preview__size" aria-live="polite">
          {preset.width} × {preset.height}
        </span>
      </div>
      <ScaledSlideRenderer {...props} viewport={{ width: preset.width, height: preset.height }} />
    </div>
  );
}
